export const CUSTOMER_CARE_TEAM = 'care-team';
export const MAS_PHONE_NUMBER = 'MASPhoneNumber';
